<template>
  <div>
    <div
      class="row tab-header-pei-container"
      :class="{ 'mobile-responsive': isMobile }"
    >
      <div
        class="col-5 col-sm-12 col-md-12 col-lg-5 col-xl-5 tab-header-pei-title"
      >
        <TitleBreadcrumb :page="page" :compact="headerCompact" />
      </div>
      <div
        class="col-7 col-sm-12 col-md-12 col-lg-7 col-xl-7 d-flex justify-content-end btn-tab-group tab-header-pei-status"
      >
        <div>
          <div
            class="col-12 d-flex flex-wrap justify-content-end content-header-custom"
          >
            <span class="tag-badge-info tag-badge-title-info pb-2 pl-3">
              Número de {{ peiTypeLabel }}
              <span class="font-weight-lighter">
                {{ peiId | peiIdFormat }}
              </span>
            </span>
            <span
              :class="
                'badge tag-badge-info tag-badge-title-info p-1 px-4 ' +
                  getPeiStatusClass(SelectedPeiStatusDescription)
              "
            >
              {{ SelectedPeiStatusDescription }}
            </span>
          </div>
          <div
            ref="headerButtonsEl"
            class="col-12 d-flex mt-3 justify-content-end pei-button-actions"
          >
            <div class="d-flex mr-2">
              <ActionButton
                v-if="
                  page.tabIndex == 1 &&
                    hasAtService &&
                    selectedPeiStatus == peiStatuses.Firmado
                "
                variant="outline-success"
                i="fas fa-arrow-circle-left"
                @click="goToAtReferrals()"
              >
                Regresar
              </ActionButton>
            </div>
            <div class="d-flex">
              <button
                id="btnHistory"
                class="btn btn-outline-success history-btn pt-1 btn-tabHeader-outline"
                :class="{ 'history-btn--compact': headerCompact }"
                title="Historial"
                @click="goToHistorialPei()"
              >
                <i class="fas fa-clock pr-1" />
                <span class="history-btn-label">Historial</span>
              </button>
            </div>
            <div
              v-if="
                page.tabIndex == 3 &&
                  selectedPeiStatus == peiStatuses.Borrador &&
                  canEditTab[3]
              "
              class="d-flex mr-2"
            >
              <ActionButton
                variant="success"
                i="fas fa-redo"
                @click="updateImpediment()"
              >
                Actualizar Impedimento
              </ActionButton>
            </div>
            <div
              v-if="
                canSave &&
                  selectedPeiStatus == peiStatuses.Borrador &&
                  canEditTab[page.tabIndex]
              "
              class="d-flex mr-2"
            >
              <!-- <button @click="save()" class="btn btn-action  pt-1"><i class="fas fa-save pr-2 fa-lg"></i>Guardar</button> -->
              <ActionButton
                variant="success"
                i="fas fa-save pr-1"
                @click="save()"
              >
                Guardar
              </ActionButton>
            </div>
            <div
              v-if="
                page.tabIndex == 9 &&
                  selectedPeiStatus == peiStatuses.Borrador &&
                  canEditTab[9]
              "
              class="d-flex mr-2"
            >
              <ActionButton variant="success" type="submit" @click="saveTab()">
                <i class="fas fa-save mr-2" />
                Guardar
              </ActionButton>
            </div>
            <div
              v-if="page.tabIndex == 4 && canEditTab[4] && !isPSC"
              class="d-flex mr-2"
            >
              <ActionButton
                variant="outline-success"
                @click="goToDownloadProgramServiceReport()"
              >
                <i class="fas fa-print" />
                Imprimir
              </ActionButton>
            </div>
            <div v-if="page.tabIndex == 10" class="d-flex mr-2">
              <div
                v-if="
                  isSignatureTab &&
                    canViewTrackingSignature &&
                    canFollowSignature
                "
                class="mr-2"
              >
                <action-button
                  variant="outline-success"
                  @click="goToSignaturePortal()"
                  i="fas fa-pen"
                  text="Seguimiento firma"
                />
              </div>
              <div class="d-flex mr-2">
                <ActionButton
                  id="btn-save-signature"
                  variant="success"
                  :disabled="isCreatingSignature"
                  @click="onSaveTab10Only()"
                >
                  <i class="fas fa-save mr-2" />
                  Guardar
                </ActionButton>
              </div>
              <div
                v-if="
                  canCreateSignatureDocument &&
                    hasAnyRequiredElectronicSignature &&
                    !canRefreshTab10 &&
                    canFollowSignature
                "
                class="d-flex mr-2"
              >
                <ActionButton
                  id="btn-create-digital-signature"
                  variant="success"
                  @click="createDocumentToSign()"
                  :disabled="isCreatingSignature"
                >
                  <i class="fas fa-file-edit mr-2" />
                  Crear documento para firmar
                </ActionButton>
              </div>
              <div v-if="canCancelDigitalSignature" class="d-flex mr-2">
                <ActionButton
                  id="btn-cancel-digital-signature"
                  variant="outline-danger"
                  @click="cancelDigitalSignature()"
                >
                  <i class="fas fa-times-circle mr-2"></i>
                  Cancelar firma
                </ActionButton>
              </div>
              <div v-if="canCancelDigitalSignatureSigned" class="d-flex mr-2">
                <ActionButton
                  id="btn-cancel-digital-signature"
                  variant="outline-danger"
                  @click="handleCancelDigitalSignatureProcess()"
                >
                  <i class="fas fa-times-circle mr-2"></i>
                  Cancelar Proceso Firma
                </ActionButton>
              </div>
              <div
                v-if="canRefreshTab10 && showDigitalSignatureActions"
                class="d-flex mr-2"
              >
                <ActionButton
                  id="btn-create-digital-signature"
                  variant="success"
                  @click="$emit('refresh-digital-signature')"
                >
                  <i class="fas fa-signature mr-2"></i>
                  Actualizar firma
                </ActionButton>
              </div>
            </div>
            <div
              v-if="
                page.tabIndex == 4 &&
                  selectedPeiStatus == peiStatuses.Borrador &&
                  canEditTab[4] &&
                  (canEnableSectionByAmendant ||
                    canEnableSectionBySubsectionAmendant ||
                    !canUseTabEditRestriction ||
                    amendantIsEmpty)
              "
              class="d-flex mr-2"
            >
              <ActionButton variant="success" @click="syncProgramServices()">
                <i class="fas fa-redo" />
                Sincronizar Servicios
              </ActionButton>
            </div>
            <div
              v-if="
                page.tabIndex == 4 &&
                  selectedPeiStatus == peiStatuses.Borrador &&
                  canEditTab[4] &&
                  (canEnableSectionByAmendant ||
                    canEnableSectionBySubsectionAmendant ||
                    !canUseTabEditRestriction ||
                    amendantIsEmpty)
              "
              class="mx-0 d-flex justify-content-end"
            >
              <ActionButton
                v-if="!isPSC"
                variant="success"
                i="fas fa-file-plus"
                @click="goToAddProgramService()"
              >
                Añadir Área
              </ActionButton>
            </div>
            <div
              v-if="
                page.tabIndex == 4 &&
                  selectedPeiStatus == peiStatuses.Firmado &&
                  canSendAcademicProgress &&
                  !isPSC
              "
              class="d-flex mr-2"
            >
              <ActionButton variant="success" @click="sendAcademicProgress()">
                <i class="fas fa-send" />
                Enviar objetivo(s) al SIE
              </ActionButton>
            </div>
            <div
              v-if="page.tabIndex == 1 && canEditTab[1]"
              class="dropdown d-flex"
            >
              <button
                id="peiTabsHeaderDD"
                class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                type="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                <i class="fas fa-list-alt" />
                <span class="px-2">Opciones</span>
                <i class="fa fa-angle-down" />
              </button>
              <div
                class="dropdown-menu dropdown-menu-right"
                aria-labelledby="peiTabsHeaderDD"
              >
                <!-- Completar -->
                <div
                  v-if="
                    canCompletePei && selectedPeiStatus == peiStatuses.Borrador
                  "
                  id="complete-pei"
                  class="dropdown-item"
                  @click="completePei()"
                >
                  <em class="fa fa-flag text-green pr-1" />
                  <span>Completar</span>
                </div>
                <!-- Documentos  -->
                <div
                  id="documents-pei"
                  class="dropdown-item"
                  @click="goToPeiDocuments()"
                >
                  <em class="fa fa-file-alt text-green pr-1" />
                  <span>Documentos</span>
                </div>
                <!-- Definir PEI o PS  -->
                <div
                  v-if="isDraftAndNoLocationRejected && !isPSC"
                  id="define-pei"
                  class="dropdown-item"
                  @click="goToPeiDefinition()"
                >
                  <em class="fa fa-check text-green pr-1" />
                  <span>Definir PEI o PS</span>
                </div>
                <!-- Hoja de Cotejo  -->
                <div
                  v-if="showChecklist"
                  id="collation-sheet-pei"
                  class="dropdown-item"
                  @click="goToCollationSheet()"
                >
                  <em class="fa fa-clipboard-list-check text-green pr-1" />
                  <span>Hoja de Cotejo</span>
                </div>
                <!-- Firmar -->
                <div
                  v-if="canSignCurrentPeiPs"
                  id="sign-pei"
                  class="dropdown-item"
                  @click="goToSignPei()"
                >
                  <em class="fa fa-pen text-green pr-1" />
                  <span>Firmar</span>
                </div>
                <!-- Borrador  -->
                <div
                  v-if="
                    selectedPeiStatus == peiStatuses.Completado && !hasAtService
                  "
                  id="draft-pei"
                  class="dropdown-item"
                  @click="goToDraftPei()"
                >
                  <em class="fa fa-file-edit text-green pr-1" />
                  <span>Borrador</span>
                </div>
                <!-- Cancelar -->
                <div
                  v-if="canCancelPei"
                  id="cancel-pei"
                  class="dropdown-item"
                  @click="onCancelPei()"
                >
                  <em class="fa fa-times-circle text-red pr-1" />
                  <span>Cancelar</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dropdown-divider mt-2 pb-2 w-100" />
    <cancel-pei-modal ref="cancelPeiModal" @save="onCancelPeiConfirmed" />
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
import generalService from '@/services/pei/general';
import TitleBreadcrumb from '@/components/common/page/TitleBreadcrumb';
import alert from '@/mixin/alert.mixin';
import loading from '@/mixin/loading.mixin';
import router from '@/router/index';
import store from '@/store/index';
import ActionButton from '@/components/common/ActionButton';
import CancelPeiModal from '@/components/pei/cancelpei/CancelPeiModal';
import peiStatuses from '@/utils/constants/pei/peiStatus';
import academicProgressService from '@/services/academicProgress';
import PermissionsNames from '@/utils/constants/permissions.js';
import { SignatureTypes } from '@/utils/constants/signature/signatureTypes';
import peiCode from '@/utils/constants/pei/peiCode';

import ErrorKeyEnum from '@/components/pei/programservice/enum/ErrorKeyEnum';

//config
import { DEPR_DIGITAL_SIGNATURE_URL, MIPE_PUBLIC_PORTAL_URL } from '@/config';

import { getSysparameterByNames } from '@/modules/system-parameter-managment/api';
import peiSections from '@/utils/constants/pei/peiSections.js';
import { SignatureStatus as documentParticipantSignatureStatus } from '@/utils/constants/signature/signatureStatus.js';
import { documentStatuses as documentSignatureStatus } from '@/utils/constants/signature/statusDocumentSignature.js';
import { AtServiceDocumentTypes } from './components/tab10/AtServiceDocumentEnum';

const SECTION_I = 1;
const SUB_SECTION_A = 33;
//constants
const SIGNATURE_TAB_INDEX = 10;

export default {
  components: {
    TitleBreadcrumb,
    ActionButton,
    CancelPeiModal,
  },
  data() {
    return {
      peiId: store.getters.SelectedPei,
      peiConfigUnilateralFlag: store.getters.getIsPs,
      peiStatuses: peiStatuses,
      isElectronic: null,
      canEditTab: [
        false,
        store.getters.HasPermission('pei.editTab1'),
        store.getters.HasPermission('pei.editTab2'),
        store.getters.HasPermission('pei.editTab3'),
        store.getters.HasPermission('pei.editTab4'),
        store.getters.HasPermission('pei.editTab5'),
        store.getters.HasPermission('pei.editTab6'),
        store.getters.HasPermission('pei.editTab7'),
        store.getters.HasPermission('pei.editTab8'),
        store.getters.HasPermission('pei.editTab9'),
        store.getters.HasPermission('pei.editTab10'),
        store.getters.HasPermission('pei.editTab11'),
      ],
      canSign: false,
      canSendAcademicProgress: store.getters.HasPermission(
        'pei.canSendAcademicProgress'
      ),
      peiDocumentAlternateParticipationDate: null,
      isCreatingSignature: false,
      // true cuando la fila de botones (Historial + acciones condicionales
      // del tab activo) realmente no cabe en su ancho disponible -- se mide
      // (ver checkHeaderOverflow), en vez de asumirlo solo por
      // isAiAssistantDocked, que se disparaba incluso en pantallas anchas
      // donde sobraba espacio de sobra.
      headerCompact: false,
    };
  },
  mixins: [alert, loading],
  props: {
    page: {
      type: Object,
      default: function() {
        return {};
      },
    },
    signatureTabIsEnable: {
      type: Boolean,
      default: false,
    },
    showSignaturesTab: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapMutations([
      'setVisiblePeiSignSection',
      'setJustSaveTab10',
      'setShowSignatureCancellationDocument',
    ]),
    // Mide el ancho real de la fila de botones (Historial + acciones
    // condicionales del tab activo, ver ref="headerButtonsEl") -- reacciona
    // igual sin importar si la angosta el panel del Asistente IA anclado, el
    // sidebar principal abierto, o simplemente cuántos botones condicionales
    // trae el tab activo.
    observeHeaderWidth() {
      if (!window.ResizeObserver || !this.$refs.headerButtonsEl) return;
      this._headerResizeObserver = new ResizeObserver(() => {
        this.$nextTick(this.checkHeaderOverflow);
      });
      this._headerResizeObserver.observe(this.$refs.headerButtonsEl);
    },
    checkHeaderOverflow() {
      const el = this.$refs.headerButtonsEl;
      if (!el) {
        this.headerCompact = false;
        return;
      }
      // scrollWidth no sirve: con overflow:visible (el default acá) no
      // refleja el desborde hacia la izquierda que genera
      // justify-content:end. Se mide el ancho real de los hijos con
      // getBoundingClientRect en su lugar.
      const children = el.children;
      if (!children.length) {
        this.headerCompact = false;
        return;
      }
      const firstLeft = children[0].getBoundingClientRect().left;
      const lastRight = children[
        children.length - 1
      ].getBoundingClientRect().right;
      this.headerCompact = lastRight - firstLeft > el.clientWidth;
    },
    goToAtReferrals() {
      let academicYearId = store.getters.getPeiInfo.academicYearId;
      let studentSieid = store.getters.SelectedStudent.studentId;
      this.$router.push({
        path: `/pei/At/search/${academicYearId}/${studentSieid}`,
      });
    },

    getPeiStatusClass(status) {
      let statusClass = '';
      //ECG:Esto se debe basar en id de estatus de pei
      switch (status) {
        case 'Borrador':
          statusClass = 'badge-erase';
          break;
        case 'Cancelado':
          statusClass = 'badge-cancel';
          break;
        case 'Completado':
          statusClass = 'badge-complete';
          break;
        case 'Completado - Controversia':
          statusClass = 'badge-complete';
          break;
        case 'Firmado':
          statusClass = 'badge-signed';
          break;
        case 'Incompleto':
          statusClass = 'badge-incomplete';
          break;
        case 'Completado – Pendiente Fondos':
          statusClass = 'badge-pending';
          break;
        case 'Discutido Pendiente de Firmas':
        case 'Firmado Parcial - Pendiente de Fondos':
          statusClass = 'badge-partial';
          break;
        case 'Firmado - Controversia':
          statusClass = 'badge-partial';
          break;
        case 'Propuesta de PEI - Rechazada':
          statusClass = 'badge-pending-funds';
          break;
      }

      return statusClass;
    },
    save() {
      // saveChangesOnForm rechaza (sin valor) cuando el guardado del tab falla; el
      // tab ya informó el error, aquí solo se evita el "Uncaught (in promise)".
      store.dispatch('saveChangesOnForm').catch(() => {});
    },
    goToPeiDefinition() {
      const peiId = store.getters.SelectedPei;
      this.$router.push({
        path: `/pei/definition/${peiId}`,
      });
    },
    async goToSignPei() {
      const peiId = store.getters.SelectedPei;
      const areAllSignatureElectronic = await this.validateAreAllSignatureElectronic();
      if (this.signatureTabIsEnable) {
        let canGoToNextStep = await this.getTabInfoToNextStep();
        if (!canGoToNextStep) {
          this.ShowToast(
            '',
            'Favor adjuntar SAEE-08a a integrante del COMPU con Participación Alterna para Firmar el PEI',
            'error'
          );
          return;
        }
      }
      if (areAllSignatureElectronic) {
        const isValid = await this.validateSignedPeiDocuments();
        if (!isValid) return;
      }

      if (!this.peiConfigUnilateralFlag) {
        const areValidPeiSignatureFiles = await this.validateCompuAndSignedPeiFiles(
          peiId,
          areAllSignatureElectronic
        );

        if (!areValidPeiSignatureFiles) return;
      }

      if (this.signatureTabIsEnable) {
        const isDigitalSignatureEnabled = await this.isDigitalSignatureEnabled();
        const hasElectronicSignatures = await this.hasAnyElectronicSignature();

        if (!isDigitalSignatureEnabled && hasElectronicSignatures) {
          this.ShowToast(
            '',
            'La firma digital está deshabilitada. Debe cambiar los participantes a tipo Manuscrito para firmar el PEI.',
            'error'
          );
          return;
        }
      }

      let self = this;
      let promise = await new Promise((resolve) => {
        self
          .$ApiPost(`/api/pei/validatepeiforsign/${peiId}`)
          .then((response) => {
            response = response.data;
            let isValid = response.every((obj) => !obj.value);

            if (!isValid) {
              let checklistobject = response.find((x) => x.id == 'CheckList');
              if (checklistobject.value) {
                self.ShowToast(
                  'Debe completar la Hoja de Cotejo',
                  checklistobject.errors[0].name,
                  'error'
                );
              }
              self.$store.commit('setSignSectionVisibles', response);
            } else {
              this.setVisiblePeiSignSection(true);
            }

            resolve(response.data);
          })
          .catch((error) => {
            if (error && error.response && error.response.data) {
              self.ShowToast('', error.response.data.message, 'error');
            } else {
              self.ShowToast(
                '',
                'Ha ocurrido un errorasdasd mientras se procesaba la información.',
                'error'
              );
            }
          });
      });
      return promise;
    },
    async validateCompuAndSignedPeiFiles(peiId, isElectronicSignature) {
      let isValid = true;
      try {
        const { data } = await this.$ApiGet(
          `/api/pei/signaturetab?peiId=${peiId}`
        );
        const { data: needs } = await generalService.getSelectedPeiServiceNeed(
          peiId
        );

        const isSaee10ValidNeeds = (needs || []).some(
          (x) =>
            x.id == peiCode.SaludConductal ||
            x.id == peiCode.SaludAnsiedadSevera
        );
        if (!!data?.pendingAtServiceDocumentTypes.length) {
          if (
            data?.pendingAtServiceDocumentTypes.includes(
              AtServiceDocumentTypes.DeliveredMinute
            )
          ) {
            this.ShowToast(
              '',
              'Minuta COMPU es requerida para Firmar el PEI.',
              'error'
            );
          }

          if (
            data?.pendingAtServiceDocumentTypes.includes(
              AtServiceDocumentTypes.EvaluationDiscussionSigned
            )
          ) {
            this.ShowToast(
              '',
              'Minuta COMPU es requerida para Firmar el PEI.',
              'error'
            );
          }

          if (
            data?.pendingAtServiceDocumentTypes.includes(
              AtServiceDocumentTypes.Estipulation80
            )
          ) {
            this.ShowToast(
              '',
              'Documento de la Estipulación 80 es requerido para Firmar el PEI.',
              'error'
            );
          }

          isValid = false;
        } else if (
          !data.isAtService &&
          this.signatureTabIsEnable &&
          this.isCompuFileParameterEnable &&
          !data.signatureFiles.compuMinutes?.fileId &&
          !store.getters.getPeiATAmmendmentInfo
        ) {
          this.ShowToast(
            '',
            'Minuta COMPU es requerida para Firmar el PEI.',
            'error'
          );

          isValid = false;
        }

        if (
          this.signatureTabIsEnable &&
          this.isSignedPeiParameterEnable &&
          !isElectronicSignature &&
          !data.signatureFiles.signedPei?.fileId
        ) {
          this.ShowToast(
            '',
            'Documento PEI firmado es requerido para Firmar el PEI.',
            'error'
          );

          isValid = false;
        }

        if (
          this.signatureTabIsEnable &&
          !isElectronicSignature &&
          !data.signatureFiles.signedSaee10?.fileId &&
          isSaee10ValidNeeds &&
          this.saee10DocumentIsRequired &&
          !store.getters.getPeiATAmmendmentInfo
        ) {
          this.ShowToast('', 'Es requerido anejar la SAEE10 Firmada.', 'error');

          isValid = false;
        }
      } catch (error) {
        isValid = false;
      }

      return isValid;
    },
    async getTabInfoToNextStep() {
      if (!this.saee08DocumentIsRequired) return true;

      try {
        const peiId = store.getters.SelectedPei;
        const res = await this.$ApiGet(`/api/pei/signaturetab?peiId=${peiId}`);
        const notRequiredSign = res.data.signatures.filter(
          (x) => !x.requireSignature
        );
        let existElementWithoutSAE08A = notRequiredSign.some(
          (item) => item.hasSae08a === false
        );
        if (existElementWithoutSAE08A) {
          return false;
        }
        return true;
      } catch (err) {
        this.response = err;
        return false;
      }
    },
    async validateSignedPeiDocuments() {
      const peiId = store.getters.SelectedPei;
      const { data } = await generalService.checkIfAnyDocumentIsRelatedToPei(
        peiId
      );

      if (!data) {
        this.ShowToast(
          '',
          'Documento PEI firmado es requerido para Firmar el PEI.',
          'error'
        );
        return false;
      }
      return true;
    },
    async validateAreAllSignatureElectronic() {
      const peiId = store.getters.SelectedPei;
      const { data } = await generalService.getTypeIdOfSignatures(peiId);
      return data.length > 0 && data.every((s) => s == SignatureTypes.email);
    },
    async hasAnyElectronicSignature() {
      const peiId = store.getters.SelectedPei;
      const { data } = await generalService.getTypeIdOfSignatures(peiId);
      return data.length > 0 && data.some((s) => s == SignatureTypes.email);
    },
    goToCollationSheet() {
      this.$router.push('/pei/collationsheet');
    },
    goToAddProgramService() {
      this.$router.push('/pei/addprogramservice');
    },
    async sendAcademicProgress() {
      await academicProgressService
        .sendAcademicProgress(store.getters.SelectedPei)
        .then(() => {
          this.ShowToast(
            '',
            'Los objetivos han sido enviado al SIE exitosamente.',
            'success'
          );
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async goToDownloadProgramServiceReport() {
      let self = this;
      const peiId = store.getters.SelectedPei;
      let promise = new Promise((resolve) => {
        self
          .$ApiGet(
            '/api/report/downloadprogramservicereport?peiId=' +
              peiId +
              '&reportName=PEIStudentServiceProgram'
          )
          .then((res) => {
            self.report = res.data;
            generalService.documentDownloadReport(
              self.report.content,
              self.report.filename
            );
            resolve(res.data);
          })
          .catch((err) => {
            self.response = err;
          });
      });
      return promise;
    },
    async onCancelPei() {
      await this.$refs.cancelPeiModal.open();
    },
    async onCancelPeiConfirmed({ peiCancelComment }) {
      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que quiere modificar el estatus del PEI o PS de “Borrador” a “Cancelado”?',
        'Sí',
        'No'
      );
      if (!answer) {
        return;
      }

      try {
        await this.cancelPei(peiCancelComment);
        this.ShowToast(
          'Proceso exitoso',
          'Se cambio el estatus del PEI a Cancelado exitosamente.',
          'success',
          function() {
            router.push({ path: '/pei/history' });
          }
        );
      } catch {
        this.ShowToast(
          'Error',
          'No ha sido posible el cambio de estatus.',
          'error'
        );
      }
    },
    async cancelPei(comment) {
      return await this.$ApiPost(
        `/api/pei/cancelpei/${store.getters.SelectedPei}`,
        { peiCancelComment: comment }
      );
    },
    goToHistorialPei() {
      router.push({ path: '/pei/history' });
    },
    async cancelDigitalSignature() {
      this.setShowSignatureCancellationDocument(true);
    },
    goToPeiDocuments() {
      router.push({ path: '/pei/documents/' });
    },
    async createDocumentToSign() {
      if (this.isCreatingSignature) {
        return;
      }

      this.isCreatingSignature = true;

      try {
        const isDigitalSignatureEnabled = await this.isDigitalSignatureEnabled();
        if (!isDigitalSignatureEnabled) {
          this.ShowToast(
            'Error',
            'Firma digital no disponible en estos momentos.',
            'error'
          );
          return;
        }

        let isValid = await this.validateStatusCheckList();
        if (!isValid) {
          return;
        }
        this.setJustSaveTab10(false);
        await this.saveTab();
      } finally {
        this.isCreatingSignature = false;
      }
    },
    async isDigitalSignatureEnabled() {
      try {
        const { data } = await getSysparameterByNames({
          parameterNames: ['UseDigitalSignature'],
        });

        const value = data?.find((item) => item.name === 'UseDigitalSignature')
          ?.staticValue;

        return `${value ?? ''}`.toLowerCase() === 'true';
      } catch (error) {
        this.ShowToast(
          'Error',
          error?.response?.data?.message ||
            'No fue posible validar la disponibilidad de firma digital.',
          'error'
        );
        return false;
      }
    },
    async validateStatusCheckList() {
      try {
        const peiId = store.getters.SelectedPei;
        await generalService.validateStatusCheckList(peiId);
        return true;
      } catch (error) {
        this.ShowToast('Error', error.response.data.message, 'error');
        return false;
      }
    },
    async onSaveTab10Only() {
      if (this.isCreatingSignature) {
        return;
      }

      this.isCreatingSignature = true;

      try {
        this.setJustSaveTab10(true);
        await this.saveTab();
      } finally {
        this.isCreatingSignature = false;
      }
    },
    saveTab() {
      return new Promise((resolve, reject) => {
        this.$emit('saveTab', { resolve, reject });
      });
    },
    async goToDraftPei() {
      const peiId = store.getters.SelectedPei;
      let self = this;
      const answer = await self.ShowCancelModal(
        'Atención',
        '¿Está seguro que quiere modificar el estatus del PEI o PS de “Completado” a “Borrador”?',
        'Sí',
        'No'
      );
      if (answer) {
        self
          .$ApiPost('api/pei/completetodraft/' + peiId)
          .then((response) => {
            return response.data;
          })
          .then(async (json) => {
            if (json.peiStatusCode == 1) {
              self.ShowToast(
                'Proceso exitoso.',
                'Se actualizó el estatus del PEI cambiado a Borrador exitosamente',
                'success'
              );

              this.$store.dispatch('setVisiblePeiSignSection', false);
              this.canSign = false;
              this.$store.dispatch('setSelectedPeiStatus', 1);
              this.$store.dispatch(
                'setSelectedPeiStatusDescription',
                'Borrador'
              );
            }
          })
          .catch((err) => {
            self.ShowToast(
              'Error',
              err.response.data.message ??
                'No ha sido posible el cambio de estatus.',
              'error'
            );
          });
      }
    },
    tab6NoJustifyError() {
      let tab6Errors = this.validationTriggered.tabValidation.find(
        (t) => t.id == 'Tab6'
      );

      if (tab6Errors) {
        return tab6Errors.errors.some((e) => e.id.startsWith('US105939'));
      }

      return false;
    },
    tab8NoJustifyError() {
      let tab6Errors = this.validationTriggered.tabValidation.find(
        (t) => t.id == 'Tab8'
      );

      if (tab6Errors) {
        return tab6Errors.errors.some((e) => e.id == 'Transportation');
      }

      return false;
    },
    hasTab4ResultSummaryError() {
      let tab4Errors = this.validationTriggered.tabValidation.find(
        (t) => t.id == 'Tab4'
      );
      if (tab4Errors) {
        return tab4Errors.errors.some((e) =>
          e.id.startsWith(ErrorKeyEnum.ResultSummary)
        );
      }

      return false;
    },
    async completePei() {
      const peiId = store.getters.SelectedPei;

      const answer = await this.ShowCancelModal(
        'Atención',
        '¿Está seguro que quiere modificar el estatus del PEI o PS de “Borrador” a “Completado”?',
        'Sí',
        'No'
      );
      if (!answer) {
        return;
      }

      try {
        const response = await this.$ApiPost(`api/pei/complete/${peiId}`);
        let tabValidations = {
          validation:
            response.data.tabValidations.filter((v) => v.value).length > 0,
          tabValidation: response.data.tabValidations,
        };

        store.dispatch('setPeiValidationTriggered', tabValidations);

        if (tabValidations.validation) {
          if (this.tab6NoJustifyError()) {
            this.ShowToast(
              'Error de validación',
              'No es posible seleccionar el asistente para transportación, ya que no se justifica el Asistente para Silla de Rueda.',
              'error'
            );
          } else if (this.tab8NoJustifyError()) {
            this.ShowToast(
              'Error de validación',
              'Asistente de transportación no está justificado',
              'error'
            );
          } else if (this.hasTab4ResultSummaryError()) {
            this.ShowToast(
              'Error de validación',
              'Se identificó que no se ha documentado si esta de acuerdo con la recomendación del resumen de resultados sometida por el especialista.',
              'error'
            );
          } else {
            this.ShowToast(
              'Error de validación',
              'Se identificó que el PEI contiene información incompleta por lo cual no se procedió con el cambio de estatus.',
              'error'
            );
          }

          return;
        }

        this.ShowToast(
          'PEI Completado exitosamente',
          'Se actualizó el estatus del PEI a completado exitosamente',
          'success'
        );

        this.$store.dispatch(
          'setSelectedPeiStatus',
          response.data.peiStatusCode
        );

        this.$store.dispatch(
          'setSelectedPeiStatusDescription',
          response.data.peiStatusDescription
        );

        if (this.signatureTabIsEnable && this.showSignaturesTab) {
          this.$emit('goToTab', 'Tab10');
        }
      } catch (err) {
        this.ShowToast('Error', err.response.data.message, 'error');
      }
    },
    updateImpediment() {
      let peiId = store.getters.SelectedPei;
      let studentSieid = store.getters.SelectedStudent.studentId;
      let self = this;
      self
        .$ApiPost('api/pei/UpdateImpediment/' + peiId + '/' + studentSieid)
        .then((response) => {
          this.$emit('updateImpedimentInfo', response);
        })
        .catch(() => {
          self.ShowToast(
            'Error',
            'No ha sido posible actualizar el impedimento.',
            'error'
          );
        });
    },
    syncProgramServices() {
      let peiId = store.getters.SelectedPei;
      let self = this;
      self
        .$ApiPost('api/pei/' + peiId + '/SyncServices')
        .then(() => {
          self.ShowToast(
            'Proceso exitoso',
            'Los datos relacioandos al Tab VIII fueron actualizados correctamente.',
            'success'
          );
        })
        .catch(() => {
          self.ShowToast(
            'Error',
            'No ha sido posible sincronizar los servicios.',
            'error'
          );
        });
    },
    async canSignPeiPs() {
      await this.$ApiGet(`/api/pei/cansignpeips/${this.peiId}`).then((res) => {
        this.canSign =
          this.selectedPeiStatus == peiStatuses.Completado && res.data;
      });
    },
    goToSignaturePortal() {
      window.open(DEPR_DIGITAL_SIGNATURE_URL, '_blank');
    },
    async handleCancelDigitalSignatureProcess() {
      const answer = await this.ShowCancelModal(
        'Atención',
        'El documento de PEI se encuentra Firmado por todos los participantes, ¿Está seguro que desea Dejar sin efecto el mismo?',
        'Sí',
        'No'
      );
      if (answer) {
        try {
          const response = await generalService.cancelDigitalSignature(
            this.peiId,
            'Documento dejado sin efecto por cancelación de proceso de firma en el PEI del estudiante.',
            true
          );
          if (response?.data) {
            this.ShowToast(
              '',
              'El proceso de firma electrónica ha sido dejado sin efecto exitosamente.',
              'success'
            );
            this.$emit('refresh-digital-signature', false);
          } else {
            this.ShowToast(
              '',
              'No hay documentos relacionados al PEI.',
              'error'
            );
          }
        } catch {
          this.ShowToast(
            '',
            'Error en el proceso de dejado sin efecto de firma digital',
            'error'
          );
        }
      }
    },
  },
  filters: {
    peiIdFormat(value) {
      return value.substring(0, 4) + ' - ' + value.substring(4);
    },
  },
  computed: {
    canFollowSignature() {
      const currentPeiStatus = this.selectedPeiStatus.toString();
      const validStatuses = [peiStatuses.Completado];

      let result =
        validStatuses.includes(currentPeiStatus) ||
        this.isDiscussedPendingSignature;

      return this.hasAnyRequiredElectronicSignature && result;
    },
    canCancelDigitalSignature() {
      const isCurrentTabSignature = this.page.tabIndex == 10;
      // User is not on the digital signature tab (Tab 10). then return false.
      if (!isCurrentTabSignature) return false;

      const validStatuses = [
        peiStatuses.Completado,
        peiStatuses.PartialSignedPendingFunds,
        peiStatuses.CompletedWithPendingFunds,
      ];

      if (this.isPS) {
        validStatuses.push(peiStatuses.Firmado);
      }

      return (
        // PEI status is one that allows canceling the digital signature process.
        validStatuses.includes(this.selectedPeiStatus.toString()) &&
        // A signature document was loaded (non-empty response from digitalsignturedocument).
        this.canRefreshTab10 &&
        // Cancellation form in Tab 10 is not open (avoid duplicate cancel UI).
        !this.showSignatureCancellationDocument &&
        // At least one participant has not signed yet (signature flow still active).
        this.showDigitalSignatureActions
      );
    },
    isPSC() {
      return store.state.pei.configUnilateralFlag == '2';
    },
    showChecklist() {
      if (this.isPSC) return false;
      return (
        [
          peiStatuses.Completado,
          peiStatuses.Firmado,
          peiStatuses.CompletedWithPendingFunds,
          peiStatuses.PartialSignedPendingFunds,
          peiStatuses.SignedWithControversy,
        ].includes(this.selectedPeiStatus?.toString()) ||
        this.isProposalRejectedLongMode
      );
    },
    peiTypeLabel() {
      const flag = store.state.pei.configUnilateralFlag;
      const map = {
        '0': 'PEI',
        '1': 'PS',
        '2': 'PSC',
      };
      return map[flag] || '';
    },
    ...mapGetters({
      showSignatureCancellationDocument: 'getShowSignatureCancellationDocument',
      isDigitalSignatureCancelled: 'getIsDigitalSignatureCancelled',
      showDigitalSignatureActions: 'getShowDigitalSignatureActions',
      isSignedPeiParameterEnable: 'isSignedPeiParameterEnable',
      isCompuFileParameterEnable: 'isCompuFileParameterEnable',
      getPeiATAmmendmentInfo: 'getPeiATAmmendmentInfo',
    }),
    isPS() {
      return store.getters.getIsPs;
    },
    hasAtService() {
      return store.getters.getPeiATAmmendmentInfo;
    },
    /// solo habilita el edit mode si el pei es borrador y el usuario ha marcado esa sección como editable para dicha enmienda
    canUseTabEditRestriction() {
      return (
        this.$store.state['$_admendment'].correlationParameter[0]
          .staticValue === 'true'
      );
    },
    amendantIsEmpty() {
      return this.$store.state['$_admendment'].sections.length == 0;
    },
    canEnableSectionByAmendant() {
      const sectionsToValidate = [
        parseInt(peiSections.I),
        parseInt(peiSections.IVV),
      ];
      return sectionsToValidate.some((sectionId) =>
        this.$store.state['$_admendment'].sections.some(
          (x) => x.sectionId == sectionId
        )
      );
    },
    canEnableSectionBySubsectionAmendant() {
      const subSectionsToValidate = [parseInt(SUB_SECTION_A)];
      return subSectionsToValidate.some((subSectionId) =>
        this.$store.state['$_admendment'].sections.some(
          (x) => x.subSectionId == subSectionId
        )
      );
    },
    canShowSectionEditable() {
      return this.canEnableSectionByAmendant && this.canUseTabEditRestriction;
    },
    validationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    isDraftAndNoLocationRejected() {
      const canGoToPeiDefinition =
        this.selectedPeiStatus == this.peiStatuses.Borrador ||
        this.selectedPeiStatus == this.peiStatuses.Completado ||
        this.selectedPeiStatus == this.peiStatuses.Firmado;
      return canGoToPeiDefinition && store.state.pei.peiLocationRejected != '1';
    },
    isProposalRejectedLongMode() {
      return (
        this.selectedPeiStatus == this.peiStatuses.ProposalRejected &&
        store.getters.getPeiInfo.peiLocationRejected != '1' &&
        store.getters.getPeiInfo.checklistStatusCode != null
      );
    },
    canSave() {
      return store.state.tab.showSaveBtn;
    },
    canViewSheetAcotejo() {
      return true;
    },
    selectedPeiStatus() {
      return store.getters.SelectedPeiStatus;
    },
    SelectedPeiStatusDescription() {
      return store.state.pei.peiStatusCodeDescription;
    },
    selectedPeiLocationRejected() {
      return store.getters.SelectedPeiLocationRejected;
    },
    isMobile() {
      return store.getters.getIsMobileDensity;
    },
    canCompletePei() {
      return store.getters.HasPermission('pei.complete');
    },
    canCancelPei() {
      return (
        this.selectedPeiStatus == peiStatuses.Borrador &&
        store.getters.HasPermission('pei.cancel')
      );
    },
    isPeiSigned() {
      return peiStatuses.Firmado == store.getters.SelectedPeiStatus.toString();
    },
    canSignCurrentPeiPs() {
      return (
        this.selectedPeiStatus == peiStatuses.Completado &&
        store.getters.HasPermission('pei.sign') &&
        this.canSign
      );
    },
    canCreateSignatureDocument() {
      return (
        this.userHasPermissions(PermissionsNames.optionelectronicsignature) &&
        this.userHasPermissions(PermissionsNames.optiondigitalsignature)
      );
    },
    canRefreshTab10() {
      return store.getters.canShowRefreshSignatureTab;
    },
    tab10IsPSSignatureFilesFlag() {
      return (
        store.getters.getTab10SignatureInfo?.isPSSignatureFilesFlag ?? null
      );
    },
    hasAnyRequiredElectronicSignature() {
      return !!store.getters.getTab10SignatureInfo?.isElectronicSignature;
    },
    isDiscussedPendingSignature() {
      const peiStatusCode = this.selectedPeiStatus?.toString();
      const allowedStatuses = [
        peiStatuses.PartialSignedPendingFunds,
        peiStatuses.CompletedWithPendingFunds,
        peiStatuses.Firmado,
      ];

      return (
        this.isPS &&
        this.tab10IsPSSignatureFilesFlag === true &&
        allowedStatuses.some((statusCode) => statusCode === peiStatusCode)
      );
    },
    isSignatureTab() {
      return this.page.tabIndex === SIGNATURE_TAB_INDEX;
    },
    canViewTrackingSignature() {
      return this.userHasPermissions('eduesp.pei.view.signaturetracking');
    },
    showAcctionSigned() {
      return (
        peiStatuses.Firmado == store.getters.SelectedPeiStatus.toString() &&
        !this.isElectronic
      );
    },
    saee08DocumentIsRequired() {
      let today = new Date();
      let dateParam = new Date(this.peiDocumentAlternateParticipationDate);
      today.setHours(0, 0, 0, 0);
      dateParam.setHours(0, 0, 0, 0);

      return dateParam && today >= dateParam;
    },
    saee10DocumentIsRequired() {
      let today = new Date();
      let dateParam = new Date(this.peiDocumentSAEE10Date);
      today.setHours(0, 0, 0, 0);
      dateParam.setHours(0, 0, 0, 0);

      return dateParam && today >= dateParam;
    },
    canCancelDigitalSignatureSigned() {
      const signatureDocument = store.getters.getSignatureDocument;
      return (
        this.page.tabIndex == SIGNATURE_TAB_INDEX &&
        [
          +peiStatuses.Completado,
          +peiStatuses.PartialSignedPendingFunds,
        ].includes(this.selectedPeiStatus) &&
        signatureDocument?.statusId === documentSignatureStatus.Signed &&
        (signatureDocument?.participants || []).every(
          (x) =>
            x.signatureStatusId === documentParticipantSignatureStatus.Signed
        )
      );
    },
  },
  async mounted() {
    await this.canSignPeiPs();
    this.isElectronic = await this.validateAreAllSignatureElectronic();

    const { data } = await getSysparameterByNames({
      parameterNames: [
        'PEIDocumentAlternateParticipation',
        'PEIDocumentSAEE10',
        'RequireUsageGuaranteeCompletion',
      ],
    });

    this.peiDocumentAlternateParticipationDate = data?.find(
      (item) => item.name === 'PEIDocumentAlternateParticipation'
    )?.staticValue;
    this.peiDocumentSAEE10Date = data?.find(
      (item) => item.name === 'PEIDocumentSAEE10'
    )?.staticValue;

    this.$store.commit(
      'setRequireUsageGuaranteeCompletionEnabled',
      data?.find((item) => item.name === 'RequireUsageGuaranteeCompletion')
        ?.staticValue
    );

    this.observeHeaderWidth();
  },
  updated() {
    // Cubre el caso en que cambian los botones condicionales visibles (ej.
    // al cambiar de tab, o cuando cambia un permiso/estatus) sin que el
    // ResizeObserver se dispare por sí solo (el ancho del contenedor no
    // cambia, solo su contenido).
    this.$nextTick(this.checkHeaderOverflow);
  },
  beforeDestroy() {
    if (this._headerResizeObserver) {
      this._headerResizeObserver.disconnect();
      this._headerResizeObserver = null;
    }
  },
};
</script>

<style lang="css">
.btn-tabHeader {
  font-size: 0.9em;
  margin-right: 10px;
  margin-top: 1px;
}

.btn-tabHeader-outline {
  font-weight: 500;
  margin-right: 10px;
  padding-bottom: 3px;
  padding-top: 4px;
}

.btn-tab-group {
  padding-right: 27px;
}

#btnHistory {
  height: 38px;
  border: 1px solid #2db782;
  color: #2db782;
  /* Evita que el texto se envuelva debajo del ícono al apretarse. */
  white-space: nowrap;
}

#btnHistory:hover {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
}

/* headerCompact (ver checkHeaderOverflow en el script) mide si la fila de
   botones realmente no cabe -- panel del Asistente IA anclado, sidebar
   principal abierto, o varios botones condicionales del tab activo a la
   vez -- y en ese caso se oculta el texto "Historial", dejando solo el
   ícono, para que no se solape con el resto de la fila. */
#btnHistory.history-btn--compact .history-btn-label {
  display: none;
}

#btnHistory.history-btn--compact i.fa-clock {
  padding-right: 0 !important;
}

/* Red de seguridad general: mismo colapso a solo-ícono en monitores angostos, con o sin
   el Asistente IA abierto -- evita el mismo solapamiento en cualquier pantalla pequeña. */
@media (max-width: 1300px) {
  #btnHistory .history-btn-label {
    display: none;
  }

  #btnHistory i.fa-clock {
    padding-right: 0 !important;
  }
}
#peiTabsHeaderDD {
  background-color: #2db782;
  border: 1px solid #2db782;
  color: #fff;
  font-weight: 400;
  width: auto;
  height: 38px;
}
#peiTabsHeaderDD i.fa-angle-down {
  font-size: 12px;
  font-weight: 400;
}
#peiTabsHeaderDD::after {
  border: none;
}
.dropdown-item {
  cursor: pointer;
  padding: 0.25rem 1rem;
}
.dropdown-item span {
  margin-left: 10px;
}
/************ CUSTOM BADGES *************/
.badges {
  color: black;
  font-size: 16px;
  width: 31%;
  height: 25px;
  line-height: 3px;
  border-radius: 20px;
  padding: 10px;
}
.badge-erase {
  background: #fcc9c8;
}
.badge-cancel {
  background: #d5b89a;
}
.badge-complete {
  background: #f8ea80;
}
.badge-signed {
  background: #a3e5b3;
}
.badge-incomplete {
  background: #d5b89a;
}
.badge-waiting {
  background: #a7e6dc;
}
.badge-partial {
  background: #a3e5b3;
}
.badge-pending-funds {
  background: #ddb3d7;
}
.badge-pending {
  background: #f8ea80;
}

.content-header-custom {
  margin-bottom: 20px;
  row-gap: 8px;
  column-gap: 8px;
}

/* El margen negativo solo tiene sentido cuando el título (izquierda) y estos
   badges (derecha) están lado a lado (mismo breakpoint que col-lg de arriba) --
   en pantallas angostas las columnas se apilan y ese margen jalaba los badges
   encima de la cola del breadcrumb. flex-wrap ya cubierto en la clase de arriba
   hace que "Número de PEI"/"Borrador" se apilen en vez de solaparse cuando no
   caben en una línea. */
@media (min-width: 992px) {
  .content-header-custom {
    margin-top: -19px;
  }
}
</style>
